export const GET_NEW_MESSAGES_COUNT = 'GET_NEW_MESSAGES_COUNT';
export const SUCCESS_GET_NEW_MESSAGES_COUNT = 'SUCCESS_GET_NEW_MESSAGES_COUNT';
export const FAILURE_GET_NEW_MESSAGES_COUNT = 'FAILURE_GET_NEW_MESSAGES_COUNT';



// WEBPACK FOOTER //
// ./js/actions/Messages.js